import script from "./WYSIWYG.vue?vue&type=script&setup=true&lang=js"
export * from "./WYSIWYG.vue?vue&type=script&setup=true&lang=js"

import "./WYSIWYG.vue?vue&type=style&index=0&id=1b68c976&lang=css"

const __exports__ = script;

export default __exports__